import { render, staticRenderFns } from "./MessList.vue?vue&type=template&id=86c198b2&scoped=true&"
import script from "./MessList.vue?vue&type=script&lang=js&"
export * from "./MessList.vue?vue&type=script&lang=js&"
import style0 from "./MessList.vue?vue&type=style&index=0&id=86c198b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c198b2",
  null
  
)

export default component.exports